module.exports = __webpack_public_path__ + "static/media/yinyin_wen.5a40db6d.png";